
import { Form } from "@/components/ui/form";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EstruturasList } from "./EstruturasList";
import { EquipamentoPadrao } from "./EquipamentoPadrao";
import { useForm, useFieldArray } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { getSistemaSalvo } from "./utils";
import { toast } from "sonner";
import { BasicInfoFields } from "./sistema/BasicInfoFields";
import { PerformanceFields } from "./sistema/PerformanceFields";
import { sistemaBaseSchema, SistemaFormValues } from "./schemas/sistemaFormSchema";
import { getTitle, getDescription } from "./sistema/sistemaTipoHelpers";

interface SistemaFormProps {
  tipo: string;
  painelImagePreview: string;
  inversorImagePreview: string;
  setPainelImagePreview: (url: string) => void;
  setInversorImagePreview: (url: string) => void;
  setPainelImage: (file: File | null) => void;
  setInversorImage: (file: File | null) => void;
  handleFileUpload: (
    e: React.ChangeEvent<HTMLInputElement>, 
    setFile: (file: File | null) => void, 
    setPreview: (url: string) => void, 
    setFormValue: (value: string) => void
  ) => void;
  onSubmit?: (data: any) => void;
}

export const SistemaForm = ({ 
  tipo,
  painelImagePreview,
  inversorImagePreview,
  setPainelImagePreview,
  setInversorImagePreview,
  setPainelImage,
  setInversorImage,
  handleFileUpload,
  onSubmit
}: SistemaFormProps) => {
  const form = useForm<SistemaFormValues>({
    resolver: zodResolver(sistemaBaseSchema),
    defaultValues: getSistemaSalvo(tipo)
  });

  const { fields } = useFieldArray({
    control: form.control,
    name: "estruturas"
  });

  const handleSalvar = (data: SistemaFormValues) => {
    localStorage.setItem(`sistema_${tipo}`, JSON.stringify(data));
    toast.success(`Sistema ${tipo} salvo com sucesso!`);
    
    if (onSubmit) {
      onSubmit(data);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>{getTitle(tipo)}</CardTitle>
        <CardDescription>
          {getDescription(tipo)}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Form {...form}>
          <form onSubmit={form.handleSubmit((data) => handleSalvar(data))} className="space-y-6">
            <BasicInfoFields form={form} />
            <PerformanceFields form={form} />
            
            <EstruturasList fields={fields} form={form} />
            
            <EquipamentoPadrao 
              form={form}
              tipoSistema={tipo}
              painelImagePreview={painelImagePreview}
              inversorImagePreview={inversorImagePreview}
              idPainel={`painel-image-${tipo}`}
              idInversor={`inversor-image-${tipo}`}
              handleFileUpload={handleFileUpload}
              setPainelImage={setPainelImage}
              setInversorImage={setInversorImage}
            />
            
            <Button type="submit" className="mt-6 flex gap-2">
              <Save className="h-4 w-4" /> Salvar Configurações
            </Button>
          </form>
        </Form>
      </CardContent>
    </Card>
  );
};
